import React, { useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FlowScreenWrapper } from "../shared/FlowScreenWrapper";
import { useAuthContext } from "../../../AuthContextWrapper";
import { RadioAndResponseForm } from "../shared/RadioAndResponseForm";
import { Estate } from "../../../models/Estate";
import { EstateUserInfo } from "models/EstateUserInfo";
import { Option } from "../../../components/ReadWriteOptionGroup"

export enum Outcomes {
  spouse = "Spouse",
  child = "Child",
  parent = "Parent",
  sibling = "Sibling",
  other = "Other family member",
  notRelated = "Not related",
  somethingElse = "Something else",
}
export const RelationshipOptions:Option[] = [
  { label: Outcomes.spouse, value: Outcomes.spouse },
  { label: Outcomes.child, value: Outcomes.child },
  { label: Outcomes.parent, value: Outcomes.parent },
  { label: Outcomes.sibling, value: Outcomes.sibling },
  { label: Outcomes.other, value: Outcomes.other },
  { label: Outcomes.notRelated, value: Outcomes.notRelated },
  { label: Outcomes.somethingElse, value: Outcomes.somethingElse },
]

export const RelationshipScreen = (): JSX.Element => {
  const navigate = useNavigate();
  const { flow, activeEstate, setActiveEstate, user } = useAuthContext()
  const { screenName } = useParams();
  const currentScreen = flow?.getCurrentFlowScreen(screenName);

  const handleComplete = async (
    relationship: string,
    more?: string
  ): Promise<boolean> => {
    if (!currentScreen) throw Error("couldn't determine currentScreen");

    // const estate = activeEstate ? Estate.from(activeEstate) : new Estate();
    const estate = activeEstate || new Estate();

    if (estate.estateUserInfo) {
    } else {
      const estateUserInfo = new EstateUserInfo(undefined, user?.id, estate.id || undefined);
      estate.estateUserInfo = estateUserInfo;
    }

    estate.estateUserInfo.relationshipToDeceased = relationship;
    estate.estateUserInfo.relationshipToDeceasedMore = more || undefined;

    try {
      await estate.saveEstate();
      setActiveEstate(estate);
    } catch (error) {
      throw new Error("could not save data");
    }

    flow?.navigateToNext(currentScreen, relationship, navigate);
    return true;
  };

  return currentScreen ? (
    <FlowScreenWrapper
      title={`What is your relationship to ${activeEstate?.deceasedFirstName}?`}
    >
      <RadioAndResponseForm
        initAnswer={activeEstate?.estateUserInfo?.relationshipToDeceased}
        initMoreAnswer={
          activeEstate?.estateUserInfo?.relationshipToDeceasedMore
        }
        answerLabel="Relationship"
        errorText={`Oops! We need to know your relationship to ${activeEstate?.deceasedFirstName}.`}
        options={[
          { value: Outcomes.spouse },
          { value: Outcomes.child },
          { value: Outcomes.parent },
          { value: Outcomes.sibling },
          { value: Outcomes.other },
          { value: Outcomes.notRelated },
          { value: Outcomes.somethingElse, followUp: "Tell us more" },
        ]}
        onComplete={handleComplete}
        onBack={() => navigate(-1)}
      />
    </FlowScreenWrapper>
  ) : (
    <></>
  );
};
